import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languageConfig from './config/languages';
import en from './locales/en.json';
import es from './locales/es.json';
import de from './locales/de.json';
import hr from './locales/hr.json';

const detectInitialLanguage = () => {
  // First check URL parameters
  const params = new URLSearchParams(window.location.search);
  const urlLang = params.get('lang') || params.get('lng');

  if (urlLang && languageConfig.isLanguageEnabled(urlLang)) {
    return urlLang;
  }

  // Then check localStorage
  const storedLang = localStorage.getItem('i18nextLng');
  if (storedLang && languageConfig.isLanguageEnabled(storedLang)) {
    return storedLang;
  }

  // Finally check browser language
  const browserLang = navigator.language || navigator.userLanguage;

  // Extract the language code (e.g., 'en' from 'en-US')
  const langCode = browserLang.split('-')[0].toLowerCase();

  // Check if the language is enabled
  if (languageConfig.isLanguageEnabled(langCode)) {
    return langCode;
  }

  // Check for full language-region match (e.g., 'hr-HR' for Croatian)
  const fullLangCode = browserLang.toLowerCase();
  for (const enabledLang of languageConfig.enabledLanguages) {
    if (fullLangCode.startsWith(enabledLang)) {
      return enabledLang;
    }
  }

  // Default to configured default language
  return languageConfig.defaultLanguage;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      es: {
        translation: es,
      },
      de: {
        translation: de,
      },
      hr: {
        translation: hr,
      },
    },
    lng: detectInitialLanguage(),
    fallbackLng: languageConfig.defaultLanguage,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
